import { createTheme, ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { GoogleMapsService } from "./services/GoogleMapsService";

import "./index.scss";
import "maplibre-gl/dist/maplibre-gl.css";

window.CESIUM_BASE_URL = "/cesium";

const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = createTheme({
	breakpoints: {
		keys: ["xs", "sm", "md", "lg", "xl"],
		values: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 },
	},
});

GoogleMapsService.init();

root.render(
	<>
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</ThemeProvider>
		<ToastContainer />
	</>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
